import { useMemo } from 'react';
import { ApolloError } from '@apollo/client/errors';
import { ApolloQueryResult } from '@apollo/client';
import {
  CollectorSettingsInput,
  CollectorSettingsUnifiedQuery,
  Exact,
  Maybe,
  useCollectorSettingsUnifiedQuery
} from 'graphql/types';

export const useCollectorSettingsUnified = (): {
  data: CollectorSettingsUnifiedQuery | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (
    variables?:
      | Partial<
          Exact<{
            input?: Maybe<CollectorSettingsInput>;
          }>
        >
      | undefined
  ) => Promise<ApolloQueryResult<CollectorSettingsUnifiedQuery>>;
} => {
  const { loading, data, error, refetch } = useCollectorSettingsUnifiedQuery({
    variables: {
      input: {
        filterByScope: null
      }
    }
  });

  return useMemo(
    () => ({
      loading,
      error,
      data,
      refetch
    }),
    [data, error, loading, refetch]
  );
};
